/*eslint-disable */
import React, { Component } from "react";
import { readOrderDispatcher } from "../../../redux/actions/allOrdersAction";
import { connect } from "react-redux";
import ReadAxios from "../../../components/axiosComponent/read";
import OrderAgGridTable from "../../../components/common/orderadGridTable";
import { translate } from "react-i18next";
import { isEmpty } from "lodash";
import { Grid, Pagination, Button } from "semantic-ui-react";
import moment from "moment";
import cogoToast from "cogo-toast";
import Vehicletyperenderer from "../../common/vehicletyperenderer";
import Sourcerender from "../../common/sourcerender";
import Destinationrender from "../../common/destinationrender";
import BLrender from "../../common/bl_no";
import Allotmentrender from "../../common/allotmentrender";
import CreateAxios from "../../axiosComponent/create"
import ReadAxiosRequestAxios from '../../axiosComponent/allAxiosCommonRequest'
import { DEMAP_INVOICE_ERROR } from "../../../utils/toastMsgConstant";
import { LOCAL_STORAGE, FEATURES, orderStatusSmall } from '../../../utils/constant'
import ConfirmationModal from "../../common/confirmationModal";

class Orders extends Component {
  constructor(props) {
    super(props);
    const { t } = props;
    this.state = {
      loadingData: true,
      generated_order: false,
      club: false,
      prevProps: [],
      OrderLists: "",
      rowData: [],
      order_status: "",
      locales: props.locales.local,
      paginationCallbackData: [],
      chunkedRowData: [],
      currentPageData: [],
      selectedRows: [],
      currentPageNumber: -1,
      componentRenderKey: 0,
      dispatch_locations: [],
      page: 0,
      totalPages: 0,
      currentPage: 1,
      itemCount: 10,
      itemsPerPage: 10,
      setPageValue: 10,
      statusFilter: "",
      searchFilterGrouping: "",
      exportDataFromSearch: null,
      status: [],
      openAcceptModal: false
    };
  }

  componentDidMount() {
    this.getDispatchLocationAPI()

    if (this.props?.pageNoOn) {
      this.setState({ currentPage: this.props.pageNoOn }, () => {
        this.getOrderInReporting(this.props.pageNoOn)
      })
    }
    else
      this.getOrderInReporting(1)
  }

  componentDidUpdate(prevProps) {
    if (this.props?.pageNoOn != prevProps.pageNoOn) {
      this.setState({ currentPage: this.props.pageNoOn }, () => {
        this.getOrderInReporting(this.props.pageNoOn)
      })
    }
  }
  openAcceptConfirmationModal = () => {
    this.setState({ openAcceptModal: true })
  }
  closeAcceptConfirmationModal = () => {
    this.setState({ openAcceptModal: false })
  }

  acceptSelectedOrders = () => {
    let orderIds = []
    this.state.selectedRows.length > 0 && this.state.selectedRows.map((obj) => {
      orderIds.push(obj.vendor_order_id)
    })
    const payload = { order_ids: orderIds }
    CreateAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/accept/selectedorders/vendor/${LOCAL_STORAGE.vendor_Id}`, payload }).then((res) => {
      if (res.data.status === 1) {
        cogoToast.success(res.data.message, { position: "top-right" })
        setTimeout(() => { 
          this.props.history.push({state:{gridview:true} });
          window.location.reload()
         }, 1000)
      } else {
        cogoToast.error(res.data.message, { position: "top-right" })
      }
    }).catch((err) => {
      console.log(err);
    })
  }

  getDispatchLocationAPI = () => {
    CreateAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API_TWO}/dispatchLocation`,
    }).then((res) => {
      this.setState({ dispatch_locations: res.data.resultSet })
    })
      .catch((err) => {
        console.log(err);
      });
  }

  externalAPIexcelDownload = () => {
    let payload = {
      bl_no: this.state?.exportDataFromSearch?.bl_no ? this.state.exportDataFromSearch.bl_no : "",
      vendor_id: this.state?.exportDataFromSearch?.vendor_id ? this.state.exportDataFromSearch.vendor_id : "",
      vehicle_no: this.state?.exportDataFromSearch?.vehicle_no ? this.state.exportDataFromSearch.vehicle_no : "",
      order_reference_no: this.state?.exportDataFromSearch?.order_reference_no ? this.state.exportDataFromSearch.order_reference_no : "",
      common_order_number: this.state?.exportDataFromSearch?.common_order_number ? this.state.exportDataFromSearch.common_order_number : "",
      delivery_reference_no: this.state?.exportDataFromSearch?.delivery_reference_no ? this.state.exportDataFromSearch.delivery_reference_no : "",
      required_on: this.state?.exportDataFromSearch?.required_on ? this.state.exportDataFromSearch.required_on : "",
      end_required_on: this.state?.exportDataFromSearch?.end_required_on ? this.state.exportDataFromSearch.end_required_on : "",
      invoice_no: this.state?.exportDataFromSearch?.invoice_no ? this.state.exportDataFromSearch.invoice_no : "",
      status: this.state.status,
      transporter_lr_no: this.state?.exportDataFromSearch?.transporter_lr_no ? this.state.exportDataFromSearch.transporter_lr_no : "",
      route_id: this.state?.exportDataFromSearch?.route_id ? this.state.exportDataFromSearch.route_id : "",
      consignor_id: this.state?.exportDataFromSearch?.consignor_id ? this.state.exportDataFromSearch.consignor_id : "",
      consignee_id: this.state?.exportDataFromSearch?.consignee_id ? this.state.exportDataFromSearch.consignee_id : "",
      from_order_created_on : this.state?.exportDataFromSearch?.from_order_created_on ? this.state.exportDataFromSearch.from_order_created_on : "",
      to_order_created_on : this.state?.exportDataFromSearch?.to_order_created_on ? this.state.exportDataFromSearch.to_order_created_on : "",
      lr_no : this.state?.exportDataFromSearch?.lr_no ? this.state.exportDataFromSearch.lr_no : "",
    }
    this.setState({ spinnerLoading: true })
    let bookingBranchIds = LOCAL_STORAGE.branch_Ids.length > 0 ? JSON.stringify(LOCAL_STORAGE.branch_Ids.toString()) : "";
    let vendorId = LOCAL_STORAGE.vendor_Id
    let urlForAgGrid = ''
    if (this.props.order_status == orderStatusSmall.alloted) {
      urlForAgGrid = `vendor`
    } else if (this.props.order_status == orderStatusSmall.reporting) {
      urlForAgGrid = `vehicle/reporting`
    } else if (this.props.order_status == orderStatusSmall.active) {
      urlForAgGrid = 'broadcast/vendor'
    }

    ReadAxiosRequestAxios({
      url: `${process.env.REACT_APP_TA_API_URL}/orders/${urlForAgGrid}/${vendorId}/excel/export?bl_no=${payload.bl_no}&vendor_name=${payload.vendor_id}&vehicle_no=${payload.vehicle_no}&delivery_reference_no=${payload.delivery_reference_no}&start_required_on=${payload.required_on}&end_required_on=${payload.end_required_on}&order_reference_no=${payload.order_reference_no}&invoice_no=${payload.invoice_no}&common_order_number=${payload.common_order_number}&booking_branch_ids=${bookingBranchIds}&status=${payload.status}&transporter_lr_no=${payload.transporter_lr_no}&route_id=${payload.route_id}&consignor_id=${payload.consignor_id}&consignee_id=${payload.consignee_id}&from_order_created_on=${payload.from_order_created_on}&to_order_created_on=${payload.to_order_created_on}&lr_no=${payload.lr_no}&page=1&limit=10&`,
      method: "get",
      noQ: true
    })
      .then((res) => {
        cogoToast.success(res.data.message);
        if (res?.status == 200) {
          this.setState({ responseReceived: true })
        }
        this.setState({ spinnerLoading: false })
      })
      .catch((err) => {
        if (err?.response?.data?.message)
          cogoToast.error(err.response.data.message);
        else
          cogoToast.error(DEMAP_INVOICE_ERROR);
        this.setState({ spinnerLoading: false })
      });
  }

  getOrderInReporting = (activePage) => {
    // console.log("MEOW table : ", this.props);
    // console.log(this.state.statusFilter)
    this.setState({loadingData : true})
    let booking_branch_ids = LOCAL_STORAGE.branch_Ids?.length > 0 ? LOCAL_STORAGE.branch_Ids.toString()
      : ''
    let vendorId = LOCAL_STORAGE.vendor_Id
    var url, results = ""
    if (this.props.order_status == orderStatusSmall.alloted) {
      url = `${process.env.REACT_APP_TA_API_URL}/orders/vendor/${vendorId}?${this.state.searchFilterGrouping}&booking_branch_ids=${booking_branch_ids}&page=${activePage}&limit=${this.state.itemsPerPage}${this.state.statusFilter}`
    }
    else if (this.props.order_status == orderStatusSmall.active) {
      url = `${process.env.REACT_APP_TA_API_URL}/orders/broadcast/vendor/${vendorId}?${this.state.searchFilterGrouping}&booking_branch_ids=${booking_branch_ids}&page=${activePage}&limit=${this.state.itemsPerPage}${this.state.statusFilter}`
    }
    else {
      url = `${process.env.REACT_APP_TA_API_URL}/orders/vehicle/reporting/${vendorId}?${this.state.searchFilterGrouping}&booking_branch_ids=${booking_branch_ids}&page=${activePage}&limit=${this.state.itemsPerPage}${this.state.statusFilter}`
    }
    ReadAxios({ completeURL: url })
      .then((res) => {
        if (this.props.order_status == orderStatusSmall.alloted || this.props.order_status == orderStatusSmall.active) {
          let result = res.data.result;
          result.forEach(element => {
            element.container_no = element?.container_no ? element.container_no : "NA";
            if (element?.dispatch_location_id && this.state.dispatch_locations.length > 0) {
              let temp = this.state.dispatch_locations.filter((item) => { if (item.id == element.dispatch_location_id) { return item } })
              element.dispatch_locations_absolute = temp?.[0]?.dispatch_location_name
            }
            else if (this.state.dispatch_locations.length == 0) {
              return element.dispatch_locations_absolute = " - "
            }
            return element

          });

          this.setState(
            {
              loadingData: false,
              rowData: result,
              order_status: this.props.order_status,
              totalPages: res.data.meta.totalPages,
            },
          );
        }
        else {
          let result = res.data.data;
          result.forEach(element => {
            element.container_no = element?.deliveries?.[0]?.container_no ? element.deliveries[0].container_no : "NA";
            return element
          });
          this.setState(
            {
              loadingData: false,
              rowData: result,
              order_status: this.props.order_status,
              totalPages: res.data.meta.totalPages,
            },
          );
        }
      })
      .catch((err) => {
        this.setState({loadingData : false})
        err.response?.data?.message && cogoToast.error(err.response?.data?.message, { position: 'top-right', heading: 'Error' , hideAfter:3});
        console.log('err', err);
      });
  }

  handlePaginationChange = (e, { activePage }) => {
    this.setState({ currentPage: activePage })
    this.props.updateGridPaginationPage(activePage)
    this.getOrderInReporting(activePage);
  }

  onCellClicked = (rowData) => {
    this.onRowEdit(rowData);
  };

  onRowEdit = (rowData) => {
    let order_id = rowData.data.vendor_order_id ? rowData.data.vendor_order_id : rowData.data.order_id
    if (this.props.allotedOrder) {
      window.open(
        `/alloted-order-details?shipmentId=${order_id}`,
        "_blank"
      );
    } else if (this.props.reportingStatusShow) {
      window.open(
        `/reporting-order-details?shipmentId=${order_id}`,
        "_blank"
      );
    }
    else {
      this.props.history.push({
        pathname: "/" + this.props.order_status + "-order-details",
        state: { item: { ...rowData.shipment } },
        search: `?shipmentId=${order_id}`,
      });
    }
  };

  handleSelect = (data) => {
    let selectedRows = data.api.getSelectedRows();
    if (selectedRows.length !== this.state.selectedRows.length) {
      this.setState({ selectedRows });
    }
  };

  checkStatus = (data) => {
    this.setState({ status: data.status })
    if (data.length !== 0) {
      let statusOrder = `&status=${data?.status ? data.status.join(',') : data ? data.join(',') : ''}`
      this.setState({ statusFilter: statusOrder }, () => {
        this.props.updateGridPaginationPage(1)
        this.getOrderInReporting(1)
      })
    } else {
      let statusOrder = `&status=`
      this.setState({ statusFilter: statusOrder }, () => {
        this.props.updateGridPaginationPage(1)
        this.getOrderInReporting(1)
      })
    }
  };

  handleMetaSearch = (payload) => {
    this.state.exportDataFromSearch = payload
    // console.log("Search Data ======> ")
    // console.log(payload)

    let url = `bl_no=${payload.bl_no}&vendor_name=${payload.vendor_id}&vehicle_no=${payload.vehicle_no}&delivery_reference_no=${payload.delivery_reference_no}&start_required_on=${payload.required_on}&end_required_on=${payload.end_required_on}&order_reference_no=${payload.order_reference_no}&invoice_no=${payload.invoice_no}&common_order_number=${payload.common_order_number}&transporter_lr_no=${payload.transporter_lr_no}&route_id=${payload.route_id}&consignor_id=${payload.consignor_id}&consignee_id=${payload.consignee_id}&from_order_created_on=${payload.from_order_created_on}&to_order_created_on=${payload.to_order_created_on}&lr_no=${payload.lr_no}`

    this.setState({ searchFilterGrouping: url }, () => {
      // console.log(url)
      this.props.updateGridPaginationPage(1)
      this.getOrderInReporting(1)
    });
  };

  render() {
    const { t, columnDefs } = this.props;
    const {
      rowData,
      generated_order,
      OrderLists,
    } = this.state;
    var frameworkcomponent = {
      vehicletyperenderer: Vehicletyperenderer,
      sourcerender: Sourcerender,
      destinationrender: Destinationrender,
      blrender: BLrender,
      allotment: Allotmentrender,
    }
    return (
      <React.Fragment>
        {/* <OrdersHeader title={t("title") || "Orders"} /> */}
        <div className="pb-2">
          <OrderAgGridTable
            hideTransporter={true}
            hideVehicleNumber={this.props.order_status == orderStatusSmall.alloted || this.props.order_status == orderStatusSmall.active ? true : false}
            showStatusFilter={true}
            hideRequired={this.props.order_status == orderStatusSmall.active ? true : false}
            hideFilter={false}
            handleMetaSearchCall={this.handleMetaSearch}
            order_status={this.props.order_status}
            toggle={this.props.toggle}
            toggleView={this.props.toggleView}
            title={this.props.title}
            columnDefs={columnDefs}
            pagination={false}
            titleBarTitle="Delivery Plan"
            baseURL={this.props.allotedOrder ? "allocatedOrdersImport" :"orders"}
            extracomponents={frameworkcomponent}
            rowData={rowData}
            checkStatus={this.checkStatus}
            suppressRowClickSelection={true}
            enableCellChangeFlash={true}
            keyIndex={"u_id"}
            onEdit={this.onRowEdit}
            cellDoubleClicked={this.onCellClicked}
            onSelectionChanged={this.handleSelect}
            defaultSelectedRows={this.state.selectedRows}
            currentPageNumber={this.state.currentPageNumber}
            OnpaginationChangeCallback={this.OnpaginationChangeCallback}
            allotedOrdersStatusShow={this.props.allotedOrdersStatusShow}
            externalAPIexcelDownload={this.externalAPIexcelDownload}
            allotedOrder={this.props.allotedOrder || false}
            reportingStatusShow={this.props.reportingStatusShow || false}
            searchLoading={this.state.loadingData}
          />
        </div>


        <div className="life-cycle w3-white p-2">

          <Pagination
            defaultActivePage={this.props.pageNoLast || this.state.currentPage}
            firstItem={null}
            lastItem={null}
            onPageChange={this.handlePaginationChange}
            pointing
            secondary
            totalPages={this.state.totalPages}
          />
          {this.state.selectedRows.length > 0 ?
            <>

              <Grid columns={2} className="ml-2 mt-1">
                <Grid.Row>
                  <Grid.Column width={3}>
                    <Button size='mini' className='w3-blue w3-round w3-hover-blue' circular type="button" onClick={this.openAcceptConfirmationModal}>{t("action_button.accept_orders") || "Accept Orders"}</Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <ConfirmationModal open={this.state.openAcceptModal} handleCancel={this.closeAcceptConfirmationModal} msgContent={t("confirmation_modal_content.accept_orders") || "Are you sure you want to accept orders?"} handleConfirm={this.acceptSelectedOrders} />

            </> : null
          }
        </div>

      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ allorders, locales, permissions, auth }) => {
  return {
    allorders,
    auth,
    permissions,
    locales,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    read: () => dispatch(readOrderDispatcher()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("orders")(Orders));
